import * as React from 'react';
import { API } from '@config/index';
import { UserContextProps, UserContext } from '@interface/index';
import { Input, Form, message, Button } from 'antd';
import { GithubOutlined, GoogleOutlined, LinkedinOutlined } from '@ant-design/icons';
import { connect, DispatchProp, Provider } from 'react-redux';
import { createStore } from 'redux';
import { reducer, StateInfo, userLogin } from '@reducer/main/login';
import { isMobilePhone } from 'validator';
import { Link, RouteComponentProps } from 'react-router-dom';
import { storeMiddleware } from '@middleware/index';
import { NiButton } from '@component/index';
import { FormattedMessage, IntlProvider } from 'react-intl';
import { getLocale, localizedString, locales, setLocale } from '@locale/index';
import { parseQuery } from '@lib/parse-query';
import * as Cookies from 'js-cookie';
import countryInput from '@component/country-input';
import { getUserInfo } from '@reducer/account/settings';
import '@style/main/login.less';

const githubLogo = require('@static/image/logos/github.png');
const googleLogo = require('@static/image/logos/google.jpg');

const AntdCountryPhoneInput = countryInput;

const combinedLogo = require('@static/image/logo.png');
const quoteLeft = require('@static/image/login/quotationtop_ic.png');
const quoteRight = require('@static/image/login/quotationright_ic.png');

export type LoginPropsInfo = StateInfo & {
  setUserData: (userData: UserContextProps) => void;
} & DispatchProp &
  RouteComponentProps<{}> &
  UserContextProps;
export interface LoginStateInfo {
  phoneError?: string;
  submitError?: string;
  authLoading?: boolean;
  phoneMode?: true;
}
const store = createStore(reducer, storeMiddleware);
class LoginComp extends React.Component<LoginPropsInfo, LoginStateInfo> {
  private mounted = false;

  constructor(props: LoginPropsInfo) {
    super(props);
    this.state = { phoneError: undefined, submitError: undefined, authLoading: false };
  }

  $phone: any = React.createRef();
  $pass: any = React.createRef();
  $form: any = React.createRef();

  componentDidMount() {
    this.mounted = true;
    const { dispatch, handleUser, history } = this.props;
    const urlQuery = parseQuery(window.location.href);

    setTimeout(() => {
      if (!this.mounted) return;

      const token = Cookies.get('token');
      if (token && token.length) {
        this.setState({ authLoading: true });
        dispatch<any>(
          getUserInfo((res: any) => {
            if (!this.mounted) return;

            handleUser(res);
            const params = new URLSearchParams(location.search);
            const redirectUrl = params.get('redirect') || undefined;

            if (redirectUrl) {
              history.push(decodeURIComponent(redirectUrl));
            } else {
              history.push('/');
            }
            this.setState({ authLoading: false });
          })
        );
      }

      if (urlQuery.dev === 'true') {
        this.setState({ phoneMode: true });
      }
    }, 500);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  validatePhone = async (rule: any, value: any) => {
    const msg = await this.isPhoneValid(value);

    this.setState({ phoneError: msg });
    if (msg) {
      return Promise.reject(msg);
    }

    return Promise.resolve();
  };

  isPhoneValid = async (phone: any): Promise<string> => {
    let result = '';
    const isPhone = phone && isMobilePhone(phone.phone, 'any');

    if (phone && !isPhone) {
      result = localizedString('phone_error');
    } else if (isPhone) {
      const userStatus = await API.user
        .isUserExist(phone.phone, phone.code, 'login')
        .catch((e: any) => {
          if (e.message) {
            result = e.message;
          }
        });
    }

    return result;
  };

  forConfigBot = () => {
    return window.location.pathname.endsWith('copilot_login');
  }

  handleLogin = (values: any) => {
    const { dispatch, history, phone, password, handleUser } = this.props;

    dispatch<any>(
      userLogin(values, (error: string, data: any, token: string) => {
        if (error) {
          this.setState({ submitError: error });

          return;
        }
        handleUser(data);

        const urlQuery = parseQuery(window.location.href);
        window.localStorage.setItem('dev', urlQuery.dev);

        const params = new URLSearchParams(location.search);
        const redirectUrl = params.get('redirect') || undefined;

        if (redirectUrl) {
          history.push(decodeURIComponent(redirectUrl));
        } else if (this.forConfigBot()) {
          history.push('/copilot');
        } else {
          history.push('/');
        }
      })
    );
  };

  render() {
    const {
      error,
      loading
    } = this.props;

    const { phoneError, submitError, authLoading } = this.state;

    return (
      <IntlProvider locale={getLocale().localeStr} messages={getLocale().messages} >
        <div className="admin-login">
          <header>
            {/* <div className="logo__wrap">
              <img src={combinedLogo} alt="naturali" />
            </div> */}
            {/* <span>
              <a href="https://www.framely.io/contact" target="_blank" className="bd-contact" >CONTACT</a>
              <span style={{ marginLeft: 48 }}>
                <span
                  className={getLocale().localeStr === 'zh' ? 'lan-selected' : 'lan-not-selected'}
                  onClick={() => {
                    setLocale(locales.zh);
                    this.setState({});
                  }}
                >
                  中
                </span> {' / '}
                <span
                  className={getLocale().localeStr === 'en' ? 'lan-selected' : 'lan-not-selected'}
                  onClick={() => {
                    setLocale(locales.en);
                    this.setState({});
                  }}
                >
                  EN
                </span>
              </span>
            </span> */}
          </header>
          <main>
            <div className="right__wrap">
              <div className="logo__wrap" style={{ width: 360, marginBottom: 24 }}>
                <img src={combinedLogo} alt="naturali" style={{ maxWidth: '40%', height: 'auto' }} />
              </div>
              <div className="login-title" style={{ width: 360, wordWrap: 'break-word', marginBottom: 24 }}>
                <h4>A BeThere product for building conversational interfaces.</h4>
              </div>
              <div className="login-title" >
                <h3>
                  <FormattedMessage id="login_title" />
                </h3>
              </div>
              <div className="operation-group">
                <Form
                  style={{ width: 360 }}
                  onFinish={this.handleLogin}
                  onValuesChange={() => {
                    this.setState({ submitError: undefined });
                  }}
                >
                  <Form.Item>
                    <Button
                      style={{ width: '100%' }}
                      onClick={this.handleGithubLogin}
                    >
                      <GithubOutlined style={{
                        width: 16,
                        height: 16,
                        marginRight: 24
                      }} />{localizedString('github_login')}
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button
                      style={{ width: '100%' }}
                      onClick={this.handleGoogleLogin}
                    >
                      <GoogleOutlined style={{
                        width: 16,
                        height: 16,
                        marginRight: 24
                      }} />{localizedString('google_login')}
                    </Button>
                  </Form.Item>
                  {/* <Form.Item>
                    <Button
                      style={{ width: '100%' }}
                      onClick={this.handleLinkedLogin}
                    >
                      <LinkedinOutlined style={{
                        width: 16,
                        height: 16,
                        marginRight: 12
                      }} />{localizedString('linkedin_login')}
                    </Button>
                  </Form.Item> */}
                  {
                    (this.state.phoneMode) &&
                    <>
                      <Form.Item>
                        <div style={{ textAlign: 'center' }}>{localizedString('common_or')}</div>
                      </Form.Item>
                      <Form.Item
                        className="user-phone"
                        name="phone"
                        rules={[
                          {
                            required: true, message: localizedString('phone_input')
                          },

                          {
                            validator: this.validatePhone
                          }
                        ]}
                        validateTrigger={['onBlur', 'onPressEnter']}
                        // validateStatus={(phoneError || error) && 'error'}
                        help={phoneError || error}
                      >
                        <AntdCountryPhoneInput
                          locale={getLocale().localeStr}
                          inputProps={{
                            autoComplete: 'username',
                            placeholder: localizedString('phone_input')
                          }}
                        />
                      </Form.Item>
                      <Form.Item
                        name="password"
                        className="user-password"
                        validateTrigger={['onBlur', 'onPressEnter']}
                        rules={[
                          {
                            required: true,
                            message: localizedString('password_input')
                          },
                          {
                            min: 6,
                            max: 20,
                            message: localizedString('password_error')
                          }
                        ]}
                      >
                        <Input
                          type="password"
                          autoComplete="current-password"
                          ref={this.$pass}
                          placeholder={localizedString('password_input')}
                        />
                      </Form.Item>
                      <Form.Item
                        validateStatus={submitError && 'error'}
                        help={submitError}
                      >
                        <NiButton
                          type="primary"
                          style={{
                            width: 360
                          }}
                          loading={loading || authLoading}
                          htmlType="submit"
                        >
                          <FormattedMessage id="login" />
                        </NiButton>
                      </Form.Item>
                    </>
                  }
                </Form>
              </div>
              {this.state.phoneMode
                ? <div className="login-footer">
                  <Link to="/register" className="link"><FormattedMessage id="register" /></Link>
                  <Link to="/find-password"><FormattedMessage id="find_password" /></Link>
                </div>
                : ''
                //  <div className="register-footer">
                //   <span className="label">{localizedString('unregistered_user_tip')}</span>
                //   <a
                //     href="https://forms.gle/nKfHHSNwxzHUWD196"
                //     target="_blank"
                //   >
                //     <FormattedMessage id="unregistered_user_link" />
                //   </a>
                // </div>
              }
            </div>
          </main>
          <p className="copyright" style={{
            textAlign: 'center',
            color: '#666',
            fontSize: '12px',
            // marginTop: '40px',
            background: 'inherit',
            paddingBottom: 24
          }}>
            BeThere, Inc © 2025 All rights reserved
          </p>        </div>
      </IntlProvider>
    );
  }

  handleGithubLogin = () => {
    API.user.githubLogin().then((res: any) => {
      window.open(res, '_self');
    }).catch((e: Error) => {
      message.error(e.message);
    });
  }

  handleGoogleLogin = () => {
    API.user.googleLogin().then((res: any) => {
      window.open(res, '_self');
    }).catch((e: Error) => {
      message.error(e.message);
    });
  }

  handleLinkedLogin = () => {
    API.user.linkedLogin().then((res: any) => {
      window.open(res, '_self');
    }).catch((e: Error) => {
      message.error(e.message);
    });
  }
}

const Login = connect(
  (state: StateInfo) => {
    return state;
  },
  (dispatch: any, ...others: any[]) => {
    return {
      dispatch
    };
  }
)(LoginComp);

export default (props: RouteComponentProps<{}>) => (
  <UserContext.Consumer>
    {(data: UserContextProps) => (
      <Provider store={store}>
        <Login {...data} {...props} />
      </Provider>
    )}
  </UserContext.Consumer>
);
